<template>
  <div class="news">
    <div class="lunbo">
      <el-carousel trigger="hover" width="520">
        <el-carousel-item v-for="(item, index) in lunbo" :key="index">
          <router-link :to="{ name: '新闻中心详情', query: { id: item.id } }">
            <img :src="item.coverImg" :alt="item.title" class="lunbo_img" />
            <p class="lunbo_title">{{ index + 1 + "、" + item.title }}</p>
          </router-link>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="xinwenList">
      <div class="xwdt">
        <div class="line_ddd">
          <div class="line_blue"></div>
        </div>
        <div class="title">
          <span>新闻动态</span>
          <router-link to="/pressCenter?number=001017&idx=0">
            <span>更多</span>
            <img src="../../../assets/img/more_blue.png" alt="" />
          </router-link>
        </div>
        <div class="dataList">
          <div v-for="(item, index) in xwdtList" :key="index">
            <router-link :to="{ name: '新闻中心详情', query: { id: item.id } }">
              <div>
                <img
                  src="../../../assets/img/arrow.png"
                  style="height: 16px; width: 10px; margin-right: 10px"
                />
                <span>{{ item.title }}</span>
              </div>
              <span>[{{ item.logintime }}]</span>
            </router-link>
          </div>
        </div>
      </div>
      <div class="jyxx">
        <div class="line_ddd">
          <div class="line_blue"></div>
        </div>
        <div class="title">
          <span>成交公告</span>
          <router-link to="/announcement?type=1">
            <span>更多</span>
            <img src="../../../assets/img/more_blue.png" alt="" />
          </router-link>
        </div>
        <div class="dataList">
          <div v-for="(item, index) in jyxxList" :key="index">
            <router-link :to="{ name: '成交公告详情', query: { id: item.id } }">
              <div>
                <img
                  src="../../../assets/img/arrow.png"
                  style="height: 16px; width: 10px; margin-right: 10px"
                />
                <span>{{ item.projectAddress }}{{ item.projectName }}</span>
              </div>
              <span>[{{ item.dealtime }}]</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewslist, publicityList } from '@/api/mian'
export default {
  data () {
    return {
      xwdtList: [],
      lunbo: [],
      jyxxList: [],
    }
  },
  async created () {
    // let data = {
    //   upnumber: '001',
    // }
    // await getNewsClass(data).then((res) => {
    //   // console.log('广告列表:', res)
    //   this.typeList = res.data.data
    //   this.typeList[0].classname = '动态新闻'
    //   console.log(this.typeList)
    // })
    let data = {
      number: '001017',
      pageSize: 10,
      pageNum: 1,
      deptId: this.$route.query.parentId
        ? this.$route.query.parentId
        : sessionStorage.getItem('deptId'),
    }
    await getNewslist(data).then((res) => {
      this.xwdtList = res.data.rows
    })
    data = {
      number: '010',
      pageSize: 4,
      pageNum: 1,
      deptId: this.$route.query.parentId
        ? this.$route.query.parentId
        : sessionStorage.getItem('deptId'),
    }
    getNewslist(data).then((res) => {
      // console.log('轮播广告', res)
      this.lunbo = res.data.rows
    })
    data = {
      number: '004',
      pageNum: 1,
      pageSize: 10,
    }
    publicityList(data).then((res) => {
      this.jyxxList = res.data.rows
    })
  },
  mounted () { },
  computed: {},
  watch: {},
  methods: {
    // 跳转到新闻中心
    toxinwen (num, i) {
      this.$router.push({ name: '新闻中心', query: { number: num, idx: i } })
    },
    // 跳转到通知成交鉴定公告页面
    toGonggao (i) {
      this.$router.push({ path: '/announcement', query: { id: i } })
    },

    // 跳转到通知成交鉴定公告页面
    toChengJiao () {
      this.$router.push({ path: '/chengjiaogonggao' })
    },
  },
}
</script>

<style scoped>
ul {
  margin: 0;
  padding: 0;
}

.news {
  display: grid;
  grid-template-columns: 2fr 3fr;
  grid-column-gap: 20px;
  width: 100%;
  /* height: 520px; */
  /* padding-top: 500px; */
  background-color: #ffffff;
  border-bottom: #6680ea 1px solid;
  /* box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1); */
}

.lunbo {
}

.lunbo_img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lunbo_title {
  display: block;
  margin: 0;
  box-sizing: border-box;
  padding: 0 130px 0 50px;
  position: absolute;
  bottom: 0;
  width: 750px;
  height: 60px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  line-height: 60px;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-carousel /deep/ .el-carousel__container {
  height: 498px !important;
}

/* ul定位 */
.el-carousel /deep/ .el-carousel__indicators--horizontal {
  left: 600px;
  transform: none;
}

.el-carousel /deep/ .el-carousel__indicators--horizontal .el-carousel__button {
  width: 12.4px;
  height: 12.4px;
  border-radius: 50%;
}
.xinwenList {
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
}
.xinwenList > div {
  display: flex;
  flex-direction: column;
}
.xinwenList > div > .title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xinwenList > div > .line_ddd {
  width: 100%;
  height: 4px;
  background-color: #ddd;
}
.xinwenList > div > .line_ddd > .line_blue {
  width: 170px;
  height: 4px;
  background-color: #6680ea;
}
.xinwenList > div > .title > a {
  display: flex;
  align-items: center;
  color: #667fea;
  cursor: pointer;
}
.xinwenList > div > .title > a > img {
  width: 10px;
  height: 10px;
}
.xinwenList > div > .title > span {
  width: 170px;
  text-align: center;
  line-height: 50px;
  height: 50px;
  font-size: 24px;
  color: #6680ea;
  font-weight: bold;
}
.xinwenList > div > .dataList {
  display: flex;
  flex-direction: column;
}
.xinwenList > div > .dataList > div {
  padding: 10px 0;
}
.xinwenList > div > .dataList > div > a {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xinwenList > div > .dataList > div > a > div {
  display: flex;
  align-items: center;
}
.xinwenList > div > .dataList > div > a > div > span {
  font-size: 18px;
  width: 380px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
